import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-01414754"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "DailyInspection"
};
var _hoisted_2 = {
  class: "container"
};
var _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"date-row\" data-v-01414754><div class=\"item\" data-v-01414754>日</div><div class=\"item\" data-v-01414754>一</div><div class=\"item\" data-v-01414754>二</div><div class=\"item\" data-v-01414754>三</div><div class=\"item\" data-v-01414754>四</div><div class=\"item\" data-v-01414754>五</div><div class=\"item\" data-v-01414754>六</div></div>", 1);
var _hoisted_4 = {
  class: "data-box"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"tip\" data-v-01414754><div class=\"item\" data-v-01414754><span class=\"s bg-green\" data-v-01414754></span>全部巡检</div><div class=\"item\" data-v-01414754><span class=\"s bg-blue\" data-v-01414754></span>有未巡检</div><div class=\"item\" data-v-01414754><span class=\"s bg-red\" data-v-01414754></span>未巡检</div><div class=\"item\" data-v-01414754><span class=\"s bg-org\" data-v-01414754></span>已选中</div></div>", 1);
var _hoisted_7 = {
  class: "data-detail"
};
var _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-01414754><div class=\"item\" data-v-01414754>区域</div><div class=\"item\" data-v-01414754>巡检点</div><div class=\"item\" data-v-01414754>已巡检</div><div class=\"item\" data-v-01414754>未巡检</div></div>", 1);
var _hoisted_9 = {
  class: "item"
};
var _hoisted_10 = {
  class: "item"
};
var _hoisted_11 = ["onClick"];
var _hoisted_12 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_c_title = _resolveComponent("c-title");
  var _component_c_date_select = _resolveComponent("c-date-select");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_c_title, {
    title: "巡检看板"
  }), _createVNode(_component_c_date_select, {
    ref: "dateSelectRef",
    onConfirmDate: _ctx.confrimDate
  }, null, 8, ["onConfirmDate"]), _hoisted_3, _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["item", _ctx.bgFormat(item === null || item === void 0 ? void 0 : item.date, item === null || item === void 0 ? void 0 : item.status)]),
      key: index,
      onClick: function onClick($event) {
        return _ctx.dateItemClick(item);
      }
    }, [_createElementVNode("span", null, _toDisplayString(_ctx.dateFormat(item === null || item === void 0 ? void 0 : item.date)), 1)], 10, _hoisted_5);
  }), 128))]), _hoisted_6, _createElementVNode("div", _hoisted_7, [_hoisted_8, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail, function (item) {
    return _openBlock(), _createElementBlock("div", {
      class: "row",
      key: item.id
    }, [_createElementVNode("div", _hoisted_9, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_10, _toDisplayString(item.point_total_num), 1), _createElementVNode("div", {
      class: "item",
      onClick: function onClick($event) {
        return _ctx.go(item.id, 1);
      }
    }, _toDisplayString(item.patrol_point_num), 9, _hoisted_11), _createElementVNode("div", {
      class: "item",
      onClick: function onClick($event) {
        return _ctx.go(item.id, 0);
      }
    }, _toDisplayString(item.not_patrol_point_num), 9, _hoisted_12)]);
  }), 128))])])]);
}